// extracted by mini-css-extract-plugin
export var sliderRange = "_cm-2";
export var sliderRoot = "_cm-0";
export var sliderThumb = "_cm-3";
export var sliderTrack = "_cm-1";